export const faqs = [
  {
    id: "faq-1",
    q: "“潘金莲电影”一般指的是什么？",
    a: "它通常是一个题材检索方向，而不是单一某部影片。泛指以潘金莲这一人物为核心或重要支线的电影、电视剧、系列影片与舞台剧目，来源多为《水浒传》和《金瓶梅》。",
  },
  {
    id: "faq-2",
    q: "本站的“电影合集”包含哪些类型？",
    a: "主要按六个方向划分：电影改编、电视剧版本、系列电影、戏曲与舞台、网络影像，以及文学原著来源。你可以从首屏入口或导航直接进入对应分区。",
  },
  {
    id: "faq-3",
    q: "“系列电影”和“改编电影”有什么区别？",
    a: "改编电影强调的是从原著文本取材的单一作品；系列电影强调的是同一题材在不同年代被反复拍摄、片名相近主创不同的作品群，更适合按年代对照浏览。",
  },
  {
    id: "faq-4",
    q: "画面里的片名、年份、主创信息准确吗？",
    a: "本站为题材方向的整理与索引，条目以方向性描述为主。具体片名、年份、主创可能因版本与发行地区不同而有差异，请以正式发行资料为准。",
  },
  {
    id: "faq-5",
    q: "可以在手机上浏览吗？",
    a: "可以。页面按桌面与移动端分别适配，筛选、标签切换与折叠内容都支持点击与键盘操作，密集内容在手机上也能顺序阅读。",
  },
];